var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-column"},[_c('MatchHeader'),_vm._v(" "),_c('MatchInfo'),_vm._v(" "),_c('MatchMenu'),_vm._v(" "),_c('MatchLoopRank'),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d421651a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/daoba-match/views/match/LoopRank.vue
// module id = null
// module chunks = 